import React, { useContext } from "react"
import { PageLayout, PageTitle } from "../components"
import { Container, Image } from "react-bootstrap"
import { Link, graphql } from "gatsby"
import { ThemeContext, SEO } from "../utils"

export default ({ data }) => {
  const MediaLink = ({ title, author, link }) => (
    <li key={title} style={{ color: "gray" }}>
      <a rel="noopener noreferrer" href={link}>
        {title}
      </a>
      &nbsp;-<i>{author}</i>
    </li>
  )

  const {
    author,
    occupation,
    readingList,
    showsList,
    designations,
    unemployed,
  } = data.site.siteMetadata
  const { toString } = useContext(ThemeContext)

  const bookLinks = readingList.map(book => MediaLink(book))
  const showLinks = showsList.map(show => MediaLink(show))

  return (
    <PageLayout>
      <SEO title="About Me" />
      <PageTitle title="About Me" />
      <Container>
        <Image
          rounded
          width="140"
          height="140"
          src={`../../icons/luke-${toString()}.png`}
          alt={author}
        />
        <article className="w-75 m-auto pt-2 text-justify">
          <p className="text-center">
            {/* {designations.map((attr, i) => (
              <span key={attr}>
                &nbsp;<b>{attr}</b>&nbsp;
                {i < designations.length - 1 && <>||</>}
              </span>
            ))} */}
            <b>Keep Moving Forward :) </b>
          </p>
          <p className="text-center">
          Hello! My name is <b>{`${author}`}</b>.
          </p>

           <p className="i-5 mt-4 pt-2">
          Enthusiast about computer science & AI since my adulthood. I’m enjoying my time doing research & develop interesting projects to make small positive changes every day in this life.
          </p>

          <p className="i-5">
            {/* I am a&nbsp;
            <a
              href="https://www.dictionary.com/e/fictional-characters/padawan/"
              target="_blank"
              rel="noopener noreferrer"
            >
              padawan
            </a> &nbsp;
            <b>{occupation}</b>  */}
            Currently, I’m co-founder & CEO at &nbsp;
            <a
              href="https://lableb.com/"
              target="_blank"
              rel="noopener noreferrer"
            >Lableb</a>
             &nbsp; which develops digital services and Arabic language technology products.
          </p>
          <p className="i-5">
            I was listed in &nbsp; 
            <a
              href="https://www.innovatorsunder35.com/the-list/kinda-altarbouch/"
              target="_blank"
              rel="noopener noreferrer"
            >MIT Innovators Under 35</a>
            &nbsp; (MENA region) in 2020.&nbsp;
            I was chosen by the &nbsp;
            <a
              href="https://arabyouthcenter.org/"
              target="_blank"
              rel="noopener noreferrer"
            >Arab Youth Center</a> 
            &nbsp;as a Young Arab Pioneer in 2017 & 2018.
            </p>
            <p className="i-5">
            Also, I’m a member of the Board of Advisory Council of &nbsp;
            <a
              href="https://popsciarabia.com/%d8%a7%d9%84%d9%85%d8%ac%d9%84%d8%b3-%d8%a7%d9%84%d8%a7%d8%b3%d8%aa%d8%b4%d8%a7%d8%b1%d9%8a/"
              target="_blank"
              rel="noopener noreferrer"
            >Popular Science Magazine (Arabic Edition)</a>
            &nbsp; since 2017 and a member of the &nbsp;
            <a
              href="https://syssr.org/"
              target="_blank"
              rel="noopener noreferrer"
            >Syrian Society for Scientific Research (SySSR)</a>
            &nbsp; since 2014.
          </p>
          <p className="i-5">
             I have served as a teaching assistant at Damascus University and scientific supervisor for the Robotic Club in the same faculty from 2015 to 2018.
             I hold a bachelor's degree in Computer Science and Artificial Intelligence from Damascus University, Syria.
          </p>
          <p className="i-5">
             In my spare time, I like to run, read different types of books, understand human psychology, and experiment with new things ;)
          </p>
          {/* <p className="i-5">
            Check out my <Link to="/projects">projects</Link> to see what I've
            been up to! Or check out my <Link to="/blog">blog</Link> to see
            what's recently caught my eye!
          </p> */}
        </article>
        {/* <article className="w-75 m-auto">
          {unemployed && (
            <>
              <hr />
              <p className="unemployed">
                <small>
                  I am <b>currently looking for new opportunities</b>! If you
                  like what you <Link to="/resume">see</Link>, let's get
                  in&nbsp;
                  <a
                    href="mailto:red.five@rebellion.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    touch
                  </a>
                  !
                </small>
              </p>
            </>
          )}
          <hr />
          <h5 className="watch-list-title pt-4">
            Here are a couple of books from my reading list:
          </h5>
          <ul style={{ fontSize: "0.9rem", listStyle: "none" }}>{bookLinks}</ul>
          <h5 className="watch-list-title pt-4">
            Here are a couple of shows from my watch list:
          </h5>
          <ul style={{ fontSize: "0.9rem", listStyle: "none" }}>{showLinks}</ul>
          <h5 className="watch-list-title pt-4">
            Here are a couple of movies from my watch list:
          </h5>
          <p>
            <i>...waaaay too many to list.</i>
          </p>
        </article> */}
      </Container>
    </PageLayout>
  )
}

export const query = graphql`
  query {
    site {
      siteMetadata {
        unemployed
        occupation
        author
        designations
        readingList {
          title
          author
          link
        }
        showsList {
          title
          author
          link
        }
      }
    }
  }
`
